<template>
    <div>
       <v-navigation-drawer
            app
            permanent
            absolute
            right
            class="sidebar_main_container"
            id="sidebar_main_container"
            >
            <div class="sidebar_inner_main_container">
                <div class="edit_your_information"><span class="icon-next" @click="back()"><IconBase><IconArrowBack /></IconBase></span> Edit your Information</div>
                
                <div class="inner_sidebar">
                    <h3>Refine your information</h3>
                    <div class="sidebar_container" @click="UpdateHeader()">
                        <router-link :to="{name:'Package'}">
                            <div class="header_sidebar">
                                <IconBase>
                                    <IconPencil/>
                                </IconBase>
                                Package
                            </div>
                            <div>{{ this.$parent.$parent.EducatorInsuranceProcess.package_code }}</div>
                        </router-link>
                    </div>
                    <div class="sidebar_container" @click="UpdateHeader()">
                        <router-link :to="{name:'HelloUser'}">
                            <div class="header_sidebar">
                                <IconBase>
                                    <IconPencil/>
                                </IconBase>
                                Personal Information
                            </div>
                            <div class="content_sidebar">
                                
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Educators[0].email_address }} 
                                <br>
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Educators[0].first_name }} 
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Educators[0].last_name }}
                                <br/>
                                DOB: 
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Educators[0].birth_day }}
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Educators[0].birth_month.text }}
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Educators[0].birth_year }}
                                
                            </div>
                        </router-link>
                    </div>
                    <div class="sidebar_container" @click="UpdateHeader()">
                        <router-link :to="{name:'YourAddress'}">
                            <div class="header_sidebar">
                                <IconBase>
                                    <IconPencil/>
                                </IconBase>
                                Address
                            </div>
                            <div class="content_sidebar">
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Addresses[0].street_number }}
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Addresses[0].address }} 
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Addresses[0].suburb }} 
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Addresses[0].state }} 
                                {{ this.$parent.$parent.EducatorInsuranceProcess.Addresses[0].postcode }}
                            </div>
                        </router-link>
                    </div>
                    <div class="sidebar_container" @click="UpdateHeader()">
                        <router-link :to="{name:'PreviousPolicies'}">
                            <div class="header_sidebar">
                                <IconBase>
                                    <IconPencil/>
                                </IconBase>
                                Declarations
                            </div>
                            <div class="content_sidebar">
                                <div>{{ this.previous_claims }}</div>
                                <div>{{ this.outstanding_claims }}</div>
                                <div>{{ this.previous_policy }}</div>
                            </div>
                        </router-link>
                    </div>
                    <div class="sidebar_container" @click="UpdateHeader()">
                        <router-link :to="{name:'EducatorStartDateOfPolicy'}">
                            <div class="header_sidebar">
                                <IconBase>
                                    <IconPencil/>
                                </IconBase>
                                Commencement Date
                            </div>
                            <div class="content_sidebar">
                                <div>{{ this.$parent.$parent.EducatorInsuranceProcess.commencement_date_display }}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
                
            </div>
        </v-navigation-drawer>
    </div>    
</template>

<script>
// class="educator-route-nav educator-package-nav no_progress_bar"
import IconBase from '@/components/IconBase.vue'
import IconArrowRight from '@/components/icons/arrowForward.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconStarCheck from '@/components/icons/starCheck.vue'
import IconPencil from '@/components/icons/pencil.vue'
//import PremiumComputation from '@/components/forms/PremiumComputation.vue'


export default {
    name: "PremiumSideBar",
    components: {
        IconBase,
        IconArrowRight,
        IconArrowBack,
        IconStarCheck,
        IconPencil
        //PremiumComputation
    },
    props: {
    },
    data() {
        return {
            previous_claims: '',
            outstanding_claims: '',
            previous_policy: '',
            edit: false,
        }
    },
    mounted(){
        this.previous_claims = this.TextForSidebar(this.$parent.$parent.EducatorInsuranceProcess.previous_claims) + 'previous claims';
        this.outstanding_claims = this.TextForSidebar(this.$parent.$parent.EducatorInsuranceProcess.outstanding_claims) + 'outstanding claims';
        this.previous_policy = this.TextForSidebar(this.$parent.$parent.EducatorInsuranceProcess.previous_policies) + 'previous policy infringement';
        this.$parent.$parent.CheckWIn
    },
    methods: {
        TextForSidebar(params) {
            if (params) {
                return 'Has ';
            } else {
                return 'No ';
            }
        },
        fullwidth_sidebar(){
            var x = document.getElementById("sidebar_main_container");
                x.classList.add("full_width_container");
                x.classList.add("block")

            this.$parent.$parent.EditStatus = true;
            
        },
        back(){
            var x = document.getElementById("sidebar_main_container");
                x.classList.remove("full_width_container");
                x.classList.remove("block")
            this.$parent.$parent.EditStatus = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    
    .header_sidebar {
        font-size: 1.2rem;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .sidebar_container {
        color: #0a2435;
    }

    .sidebar_container a {
        text-decoration: none;
        color: #0a2435;
    }

    .sidebar_container {
        margin-bottom: 20px;
    }

    .content_sidebar {
        font-size: 1.1rem;
        line-height: 35px;
    }

    .inner_sidebar {
        padding: 25px 25px;
    }

    @media screen and (max-width: 1264px) and (min-width: 0px) {
        .sidebar_main_container {
            display: none;
        }

        .full_width_container{
            width: 100% !important;
        }

    }

    @media screen  and (min-width: 1265px) {
        .edit_your_information{
            display:none;
        }
    }

    
    .block{
        display: block;
    }

    .edit_your_information{
        font-size: 2rem;
        font-weight: 501;
        color: #0a2435;
        vertical-align: middle;
        height: 75px;
        border-bottom: 1px solid #DBDBDB;
        padding: 15px 10px;
    }

    .icon-next svg{
        width: 45px;
        height: 28px;
        vertical-align: middle
    }



</style>
